import NotificationsForm from "../../components/organism/NotificationsPage/NotificationsForm";
import NotificationsList from "../../components/NotificationsScreen/NotificationsList";
import useNotificationsList from "../../services/utils/custom hooks/Notifications/useNotificationsList";
import { useState } from "react";

function NotificationsInboxPage(): JSX.Element {
  const [params, setParams] = useState<string>("");
  const [filters, setFilters] = useState({});
  const {
    data: notificationsList,
    isLoading,
    isError,
  } = useNotificationsList({ params });

  return (
    <>
      <div className="py-4 md:px-5 px-3 bg-white">
        <NotificationsForm setParams={setParams} setFilters={setFilters} />
      </div>
      <div className="pb-36 mx-5 max-h-100vh overflow-y-auto">
        <NotificationsList
          notificationsList={notificationsList?.data ?? []}
          fetchingNotifications={isLoading}
          fetchingNotificationsError={isError}
          filters={filters}
        />
      </div>
    </>
  );
}

export default NotificationsInboxPage;
